import { getUserAllowedStatuses } from 'modules/get-user-allowed-statuses/get-user-allowed-statuses';

export function getUserAllowedStatusKeys() {
  return Object.keys(getUserAllowedStatuses());
}
